import React from 'react'
import * as C from "../componentsM/index";

const StudentPersonalDevelopment = () => {
    return (
        <>

            <C.Hero title={"STUDENT PERSONAL DEVELOPMENT"} image={"/hero/21.jpg"} />

            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>


                    <p>The central theme of the mission statement of the school is the preparation of the young to make informed decisions for themselves and others during their lives. As our life path can be defined by a series of our decisions, we need to understand the mechanics behind decision-making, visualise and analyse each decisions’ consequence and learn to live with each decision.</p>

                    <p>Keeping the above in mind, the student development programme, based on the IB learner profile, allows for students involvement in school to experience the challenge of decision-making. Also, the curriculum has embedded in it academic and non-academic IB learner profile activities for all age groups of the school. As it is personal development its progress is jointly monitored by the TIS community (students, TIS staff, parents) through written or spoken reflections by the students.</p>


                    <p>IB learners strive to be:</p>






                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>
                        Enquirers
                    </h1>

                    <p>We nurture our curiosity, developing skills for enquiry and research. We know how to learn independently and with others. We learn with enthusiasm and sustain our love of learning throughout life.</p>







                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>
                        Knowledgeable
                    </h1>

                    <p>We develop and use conceptual understanding, exploring knowledge across a range of disciplines. We engage with issues and ideas that have local and global significance.</p>






                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>
                        Thinkers
                    </h1>

                    <p>We use critical and creative thinking skills to analyse and take responsible action on complex problems. We exercise initiative in making reasoned, ethical decisions.</p>






                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>
                        Communicators
                    </h1>

                    <p>
                        We express ourselves confidently and creatively in more than one language and in many ways. We collaborate effectively, listening carefully to the perspectives of other individuals and groups.
                    </p>







                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>
                        Principled
                    </h1>

                    <p>
                        We act with integrity and honesty, with a sense of fairness and justice, and with respect for the dignity and rights of people everywhere. We take responsibility for our actions and their consequences.
                    </p>






                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>
                        Open-minded

                    </h1>

                    <p>
                        We critically appreciate our own cultures and personal histories, as well as the values and traditions of others. We seek and evaluate a range of view points, and we are willing to grow from the experience.
                    </p>






                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>
                        Caring

                    </h1>

                    <p>
                        We show empathy, compassion and respect. We have a commitment to service, and we act to make a positive difference in the lives of others and in the world around us.
                    </p>




                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>
                        Risk-takers
                    </h1>

                    <p>
                        We approach uncertainty with forethought and determination; we work independently and cooperatively to explore new ideas and innovative strategies. We are resourceful and resilient in the face of challenges and change.
                    </p>





                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>
                        Balanced
                    </h1>

                    <p>
                        We understand the importance of balancing different aspects of our lives—intellectual, physical and emotional—to achieve well-being for ourselves and others. We recognise our interdependence with other people and with the world in which we live.
                    </p>






                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>
                        Reflective
                    </h1>

                    <p>
                        We thoughtfully consider the world and our own ideas and experience. We work to understand our strengths and weaknesses in order to support our learning and personal development.
                    </p>





                </div>


            </section>

        </>
    )
}

export default StudentPersonalDevelopment